
import React, { Component } from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { connect } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import {
    GET_PROJECT_ACTION_TYPE
} from '../../sagas/project';

import Loading from '../../components/common/Loading';
import AppNavigation from '../../components/app/AppNavigation';

import ProjectOverview from '../../components/projectOverviewPage/ProjectOverview';

const classNames = mergeStyleSets({
    projectOverwiewPage: {
        height: '100vh',
        width: '100vw'
    }
});

class ProjectOverviewPage extends Component {

    componentDidMount() {
        this.checkFetchProject();
    }

    componentDidUpdate(prevProps, prevState) {
        this.checkFetchProject();
    }

    checkFetchProject() {
        const notLoaded = (!this.props.project.loaded && !this.props.project.loading && !this.props.authLoading);
        const anotherId = (this.props.project.loaded && (this.props.project.data.project.id != this.props.id)); // eslint-disable-line eqeqeq
        const error = (this.props.project.error)
        if ((notLoaded || anotherId) && (!error))  {
            this.props.getProject(this.props.token, this.props.id);
        }
    }

    isProjectLoaded() {
        return (
            this.props.project.loaded &&
            !this.props.project.loading &&
            // eslint-disable-next-line eqeqeq
            (this.props.project.data.project.id == this.props.id)
        );
    }

    render() {
        return (
            <Stack verticalFill className={classNames.projectOverwiewPage}>
                <Stack.Item grow>
                {(this.isProjectLoaded())
                    ? <Stack horizontal verticalFill>
                        <Stack.Item grow>
                            <AppNavigation
                                pageId="projectView"
                                project={this.props.project.data.project}
                            />
                            <ProjectOverview
                                project={this.props.project}
                                loaded={this.isProjectLoaded()}
                            />
                        </Stack.Item>
                    </Stack>
                    : <Loading />
                }
                </Stack.Item>
            </Stack>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getProject: (token, id) => dispatch({type: GET_PROJECT_ACTION_TYPE.DEFAULT, token, id})
    };
}

function mapStateToProps(state, ownProps) {
    return {
        id: ownProps.match.params.id,
        project: state.project,
        operationRunning: state.operationStatus.operationRunning,
        token: state.auth.data ? state.auth.data.user.token : null,
        loggedUser: state.auth.data ? state.auth.data.user : null,
        authLoading: state.auth.loading
    };
}

const ConnectedProjectOverviewPage = connect(mapStateToProps, mapDispatchToProps)(ProjectOverviewPage);

export default ConnectedProjectOverviewPage;
